import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as Logger from "js-logger";
import template from "./products.vue";
import * as Store from "../../store";
import Product from "../../models/Product";
import Vue2Filters from "vue2-filters";

@Component({
  mixins: [template, Vue2Filters.mixin]
})
export default class Products extends Vue {
  search: string = "";
  sortBy: string = "title";
  sortOrder: number = 1;
  /*************************************************/
  /* LIFE CYCLE EVENTS */
  /*************************************************/
  created() {
    Store.loadProducts(this.$store);
  }

  mounted() {
    // See: https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks
  }

  get isLoading(): boolean {
    return Store.readLoaderVisibility(this.$store);
  }
  get products(): Array<Product> {
    return Store.readProducts(this.$store).filter(
      product =>
        this.search == "" ||
        product.title
          .toLocaleLowerCase()
          .indexOf(this.search.toLocaleLowerCase()) >= 0
    );
  }

  changeSort(sortBy: string) {
    if (this.sortBy == sortBy) {
      this.sortOrder = this.sortOrder * -1;
    } else {
      this.sortOrder = 1;
    }
    this.sortBy = sortBy;
  }

  addToBasket(product: Product) {
    Store.commitBasket(this.$store, product);
  }

  isInBasket(product: Product): boolean {
    return Store.isInBasket(this.$store)(product);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/products/index.ts